import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/** A small "Demo" pill, shown only while the session is in the demo workspace, so demo is never mistaken for real data. */
/**
 * The flag, or false when there is no AuthProvider above (the account shell is also rendered on its own in
 * tests): a missing session just means no badge. useAuth always runs its one useContext call before it
 * throws, so the hook order never changes.
 */
function useDemoFlag(): boolean {
  try { return useAuth().isDemo === true; } catch { return false; }
}

const DemoBadge: React.FC = () => {
  if (!useDemoFlag()) return null;
  return (
    <span
      className="ds-badge ds-badge-warning"
      title="You are in the demo workspace. This is sample data, not a real project."
    >
      Demo
    </span>
  );
};

export default DemoBadge;
